export default __webpack_public_path__ + "static/media/performance.fab3d5f4.gif";